<template>
	<div class="d-flex align-items-center min-vh-100 overflow-hidden">
		<div class="container">
			<div class="text-center" v-if="loading">
				<loading-spinner
					:overlay="loading"
					:text="$t('text.loading-data')"
				></loading-spinner>
			</div>
			<div class="row" v-if="page == 'select-exam' && !loading">
				<div class="col-12" v-if="exams.length > 0">
					<h4 class="text-center text-uppercase">{{$t('text.available-exams')}}</h4>
					<div class="card mt-3" v-for="organization in organizations" :key="organization.id" v-show="getExamsByOrganization(organization.id).length > 0">
						<h6 class="card-header bg-white text-center">{{organization.name}}</h6>
						<div class="table-responsive">
							<table class="table table-hover align-middle mb-0">
								<tbody>
									<tr v-for="exam in getExamsByOrganization(organization.id)" :key="exam.id">
										<td class="text-center">
											<div v-for="discipline in exam.disciplines">- {{discipline.name}}</div>
										</td>
										<td width="20%" class="text-center">{{exam.group_name}}</td>
										<td width="75" class="text-center">{{exam.lang.toUpperCase()}}</td>
										<td width="70" class="text-center">{{exam.questions_count}}<br/>{{$t('text.questions-count-cut')}}</td>
										<td width="70" class="text-center">{{exam.timer}}<br/>{{$t('text.mins')}}</td>
										<td width="110" class="text-end">
											<button type="button" @click="onSelectExam(exam.id)" class="btn btn-outline-primary">{{$t('btn.select')}}</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="col-12 text-center" v-else>
					<h4 class="text-uppercase">{{$t('text.available-exams-empty')}}</h4>
				</div>
			</div>
			<div class="row" v-if="page == 'select-student' && !loading">
				<div class="col-12">
					<div class="card mb-3">
						<div class="card-body">
							<div class="row">
								<div class="col-md-3 text-md-end"><b>{{$t('text.group')}}:</b></div>
								<div class="col-md-9">{{selExam.group_name}}</div>
							</div>
							<div class="row">
								<div class="col-md-3 text-md-end"><b>{{$t('text.lang')}}:</b></div>
								<div class="col-md-9">{{selExam.lang.toUpperCase()}}</div>
							</div>
							<div class="row">
								<div class="col-md-3 text-md-end"><b>{{$t('text.disciplines')}}:</b></div>
								<div class="col-md-9">
									<div v-for="discipline in selExam.disciplines">- {{discipline.name}}</div>
								</div>
							</div>
							<div class="text-center mt-3">
								<button type="button" @click="onBack()" class="btn btn-outline-secondary">{{$t('btn.select-another-exam')}}</button>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12" v-if="students.length > 0">
					<h4 class="text-center text-uppercase">{{$t('text.available-students')}}</h4>
					<div class="card mt-3">
						<div class="table-responsive">
							<table class="table table-hover align-middle mb-0">
								<thead>
									<tr>
										<th class="text-center">{{$t('text.fio')}}</th>
										<th width="100" class="text-center">{{$t('text.status')}}</th>
										<th width="100" class="text-center">{{$t('text.time')}}</th>
										<th width="110"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="student in students" :key="student.id">
										<td class="text-center">{{student.fio}}</td>
										<td class="text-center" :class="{
											'text-warning': student.status == 'started',
											'text-success': student.status == 'ended'
										}">{{$t('exams.students.statuses.'+student.status)}}</td>
										<td class="text-center" :class="{
											'text-primary': student.status != 'ended'
										}">
											<div v-if="student.status == 'waiting'">0</div>
											<div v-else-if="student.status == 'ended'">
												{{getDateDuration(student.date_start, student.date_finish)}}
											</div>
											<div v-else-if="student.status == 'started'">
												{{getDateDuration(student.date_start)}}
											</div>
											<div>{{$t('text.mins')}}</div>
										</td>
										<td class="text-end">
											<div class="btn btn-outline-primary" @click="onSelectStudent(student.id)" v-if="student.status != 'ended'">{{$t('btn.select')}}</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="col-12 text-center" v-else>
					<h4 class="text-uppercase">{{$t('text.available-students-empty')}}</h4>
				</div>
			</div>
			<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
				{{error}}
				<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'KMIB EDU Exam'});
	},
	data: () => ({
		page: 'select-exam',
		sel_exam_id: '',
		sel_student_id: '',
		
		organizations: [],
		exams: [],
		students: [],
		
		loading: false,
		error: '',
	}),
	computed: {
		selExam(){
			return this.exams.find(el => el.id == this.sel_exam_id);
		},
	},
	methods: {
		formatDate: lib.formatDate,
		
		getDateDuration(date_start, date_finish){
			return (date_finish ?
					lib.dateDiff(date_start, date_finish).minutes
				:
					lib.dateDiff(date_start, new Date().toUTCString()).minutes
				);
		},
		
		async loadOrganizations(){
			this.loading = true;
			this.error = '';
			let ret = await this.appModel.doGetOrganizations();
			if(ret.success){
				this.organizations = ret.list;
			}
			this.loading = false;
		},
		async loadExams(){
			this.loading = true;
			this.error = '';
			let ret = await this.appModel.doGetExamsToday();
			if(ret.success){
				this.exams = ret.list;
			}
			this.loading = false;
		},
		async loadStudents(){
			this.loading = true;
			this.error = '';
			let ret = await this.appModel.doGetExamStudents(this.sel_exam_id);
			if(ret.success){
				this.students = ret.list;
			}
			this.loading = false;
		},
		
		getExamsByOrganization(organization_id){
			return this.exams.filter(el => el.organization_id == organization_id);
		},
		
		async onSelectExam(exam_id){
			this.sel_exam_id = exam_id;
			this.students = [];
			await this.loadStudents();
			this.page ='select-student';
			
		},
		onSelectStudent(student_id){
			const exam = this.selExam;
			const student = this.students.find(el => el.id == student_id);
			
			this.$swal({
				title: this.$t('title.confirm-start-exam'),
				html: (`
					<div class="mb-3">${this.$t('text.confirm-start-exam.1')}:</div>
					<div><strong>${student.fio}</strong></div>
					<div>${this.$t('text.group')}: ${exam.group_name}</div>
					<div class="mt-3">${this.$t('text.confirm-start-exam.2')}</div>
					<div class="alert alert-warning mt-3 mb-0">${this.$t('text.warning.confirm-start-exam')}</div>
				`),
				icon: 'question',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-lg btn-primary mb-2 me-2',
				cancelButtonClass: 'btn btn-lg btn-outline-secondary mb-2',
				confirmButtonText: this.$t('btn.start-exam'),
				cancelButtonText: this.$t('btn.cancel'),
				buttonsStyling: false,
			}).then(async (result) => {
				if(result.isConfirmed){
					this.$swal({
						title: this.$t('text.questions-formation'),
						icon: 'info',
						buttonsStyling: false,
						allowOutsideClick: false,
						allowEscapeKey: false,
						allowEnterKey: false,
						showConfirmButton: false,
					});
					const ret = await this.appModel.doStartExam(exam.id, student_id);
					this.$swal.close();
					if(ret.success){
						this.$router.push({path: '/exam'});
					} else {
						this.error = ret.message;
					}
				}
			});
		},
		onBack(){
			this.page ='select-exam';
			this.students = [];
		},
	},
	async mounted(){
		this.appModel.pageTitle = 'title.exam';
		
		await this.loadOrganizations();
		await this.loadExams();
	},
	beforeMount(){
		if(this.authModel.isAuth()){
			if(this.authModel.isAdmin()){
				this.$router.push({path: '/admin'});
			} else if(this.authModel.isEditor()){
				this.$router.push({path: '/editor'});
			} else if(this.appModel.isExamStarted()){
				this.$router.push({path: '/exam'});
			}
		}
		document.body.classList.add('bg-light');
	},
	beforeUnmount(){
		document.body.classList.remove('bg-light');
	},
	beforeRouteUpdate(to, from, next){
		document.body.classList.add('bg-light');
		//window.scrollTo(0, 0);
		next();
	},
	components: {
		LoadingSpinner,
	},
};
</script>